import * as React from 'react'
import { Button } from '../ui/button'
import { Input } from '../ui/input'
import { Label } from '../ui/label'
import FlashAlert from './FlashAlert'
import SocialAuthButtons from './SocialAuthButtons'

interface IProps {
	title: string
	emailLabel: string
	emailFieldName: string
	emailValue?: string
	passwordLabel: string
	passwordFieldName: string
	forgotPasswordLabel: string
	forgotPasswordUrl: string
	submitLabel: string
	continueWithLabel?: string
	microsoftAuthUrl?: string
	googleAuthUrl?: string
	noAccountLabel: string
	signUpLabel: string
	signUpUrl: string
	flashMessage?: string
	flashType?: string
}

export default function LoginFormFields({
	title,
	emailLabel,
	emailFieldName,
	emailValue,
	passwordLabel,
	passwordFieldName,
	forgotPasswordLabel,
	forgotPasswordUrl,
	submitLabel,
	continueWithLabel,
	microsoftAuthUrl,
	googleAuthUrl,
	noAccountLabel,
	signUpLabel,
	signUpUrl,
	flashMessage,
	flashType,
}: IProps) {
	return (
		<div className="flex flex-col gap-6">
			<div className="flex flex-col items-center gap-2 text-center">
				<h1 className="text-2xl font-bold">{title}</h1>
			</div>

			<FlashAlert message={flashMessage} type={flashType} />

			<div className="flex flex-col gap-2">
				<Label htmlFor="session_email">{emailLabel}</Label>
				<Input
					id="session_email"
					name={emailFieldName}
					type="email"
					defaultValue={emailValue}
					autoComplete="off"
					required
				/>
			</div>

			<div className="flex flex-col gap-2">
				<div className="flex items-center">
					<Label htmlFor="session_password">{passwordLabel}</Label>
					<a href={forgotPasswordUrl} className="ml-auto text-sm underline-offset-2 hover:underline">
						{forgotPasswordLabel}
					</a>
				</div>
				<Input id="session_password" name={passwordFieldName} type="password" autoComplete="off" required />
			</div>

			<Button type="submit" className="w-full">
				{submitLabel}
			</Button>

			{microsoftAuthUrl && googleAuthUrl && (
				<SocialAuthButtons
					continueWithLabel={continueWithLabel ?? ''}
					microsoftAuthUrl={microsoftAuthUrl}
					googleAuthUrl={googleAuthUrl}
				/>
			)}

			<p className="text-center text-sm text-muted-foreground">
				{noAccountLabel}{' '}
				<a href={signUpUrl} className="underline underline-offset-4">
					{signUpLabel}
				</a>
			</p>
		</div>
	)
}
